(function(){
  'use strict';  

  theme.Promotion = (function() {
    function Promotion(container) {
      this.container = container;
      this.init() 
    }
    
    Promotion.prototype = Object.assign({}, Promotion.prototype, {
      init: function() {
        this.sectionId = this.container.getAttribute('data-section-id')
        var enableSlideshow = this.container.dataset.slideshow && this.container.dataset.slideshow == "true" ? true : false
        this.isEqualHeight = this.container.classList.contains("grid--equal-height") ? true : false
        this.windowWidth = window.innerWidth;

        this.initPackeryDefaults()

        if (enableSlideshow) {
          this.flickityDefaults = { 
            contain: true, 
            adaptiveHeight: true,
            pageDots: true,
            autoPlay: false,
            prevNextButtons: true,
            pauseAutoPlayOnHover: true,
            watchCSS: true
          };
        }

        if (window.matchMedia('screen and (min-width: 769px)').matches || !enableSlideshow) {
          setTimeout(function() { this.initGrid() }.bind(this), 50);
        } else {
          this.initSlider()
        }

        if (enableSlideshow) {
          window.on('resize', theme.Helpers.debounce(300, function() {
            if (window.innerWidth != this.windowWidth) {this.windowWidth = window.innerWidth}else{return}
            this.resize(); 
          }.bind(this)));
        }

        this.container.querySelectorAll(".tab-switcher__trigger").forEach(trigger => {
          trigger.on('click', this.switch.bind(this));
        });

        window.on('resize', theme.Helpers.debounce(300, function() {
          if (this.isEqualHeight) {
            this.initPackeryDefaults()
          }

          setTimeout(function() { this.pckry.layout() }.bind(this), 50);
        }.bind(this)));


 
        if (this.container.dataset.zoom == "true") {
          var imageZoom = new theme.ImageZoom(this.container, this.sectionId);
        }
        
      },

      initGrid: function() {
        
        this.pckry = new Packery(this.container, this.packeryDefaults);

        if (this.pckry.element.querySelector(".medium-up--height")) {
          setTimeout(function() { this.pckry.layout() }.bind(this), 50);
        }
      },

      initSlider: function() {
        this.flickity = new theme.Slideshow(this.container, this.flickityDefaults); 

        setInterval(function(){
          this.flickity.resize()
        }.bind(this),500);
      },

      resize: function() {
        if (window.matchMedia('screen and (min-width: 769px)').matches) {
          setTimeout(function() { this.initGrid() }.bind(this), 50);
        } else {
          this.pckry.destroy()
          this.initSlider()
        }
      },

      initPackeryDefaults: function() {
        var gridId = '.grid__item--' + this.sectionId
        var biggestHeight = 0;

        var gutter = parseInt(this.container.dataset.gutter)
        if (window.matchMedia('screen and (max-width: 589px)').matches && gutter > 0) {
          gutter = 15
        }

        if (this.isEqualHeight && window.matchMedia('screen and (min-width: 590px)').matches) {
          this.container.querySelectorAll(gridId).forEach(function(element, index){
            element.style.height = "unset"
            biggestHeight = element.offsetHeight > biggestHeight ? element.offsetHeight : biggestHeight;
          });
  
          if (biggestHeight > 0) {
            this.container.querySelectorAll(gridId).forEach(function(element){
              element.style.height = biggestHeight + "px"
            });
          }
        }

        if (this.isEqualHeight && this.pckry) {
          if (window.matchMedia('screen and (min-width: 590px)').matches) {
            this.pckry.options.rowHeight = 0
          } else {
            this.pckry.options.rowHeight = 0
          }
        }
        
        this.packeryDefaults = {
          itemSelector: gridId,
          gutter: gutter,
          rowHeight: biggestHeight
        }
        
      },
      
      switch: function(evt) {
        setTimeout(function() { this.pckry.layout() }.bind(this), 50);        
      }
    });
  
    return Promotion
  })();
          
  function DOMCollectionready(callback) {
    if (document.readyState != 'loading') callback();
    else document.addEventListener('DOMContentLoaded', callback);
  }

  DOMCollectionready(function(){
    theme.sections.register('promotion', theme.Promotion);
  });
})();